<template>
    <v-menu rounded="lg" offset-y :close-on-content-click="true">
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          depressed
          text
          v-bind="attrs"
          v-on="on"
          class="btnLang"
        >
          {{ $t('label.language') }} ({{ $i18n.locale }})
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="item in languages"
          :key="item.code"
          @click="changeLanguage(item)"
        >
          <v-list-item-title v-text="item.name"></v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
</template>

<script>
export default {
  name: 'LanguageMenu',
  data: () => ({
    languages: [
      { name: 'English', code: 'en' },
      { name: 'Español', code: 'es' }
    ]
  }),
  methods: {
    changeLanguage (lang) {
      if (this.$i18n.locale === lang.code) {
        return
      }
      this.$i18n.locale = lang.code
      this.$vuetify.lang.current = lang.code
      localStorage.setItem('vendorPortalLang', lang.code)
    }
  }
}
</script>

<style scoped>
  .btnLang {
    margin-right: 15px;
  }
</style>
